t = require('views/internal/teacup-with-helpers')('popover_change_board_org')

module.exports = t.renderable ({ orgs, allowsSelfJoin, hasOrg, isPrivate, isDesktop, addToTeam }) ->
  t.form ->
    t.label ->
      t.format('this-board-is-part-of')
    t.select '.js-org', ->
      t.optionSelected !orgs, { value: '' }, ->
        t.format('personal-boards-no-team')
      for org in orgs
        t.optionSelected org.select, { value: org.id }, ->
          t.text org.displayName

    t.div '.spinner.loading.js-loading.hide'

    t.div '.js-loaded.hide', ->
      t.div '.js-billable-guests-warning.move-board-to-org.hide'

      t.div '.js-permissions.hide', ->
        if isPrivate
          t.div '.check-div.js-check-div', ->
            t.input '.js-make-org-visible', { type: 'checkbox', checked: (if hasOrg then false else true), id: 'orgVisible' }
            t.label { for: 'orgVisible' }, ->
              t.format 'make-board-visible-to-organization'

        if !allowsSelfJoin
          t.div '.check-div.js-check-div', ->
            t.input '.js-make-org-joinable', { type: 'checkbox', checked: true, id: 'orgJoinable' }
            t.label { for: 'orgJoinable' }, ->
              t.format 'allow-any-org-member-to-join-this-board'

      t.div '.board-limits-upgrade-ad.js-board-limits-upgrade-ad.hide', ->
        t.p ->
          if isDesktop
            t.format 'board-cant-be-moved-because-of-board-limits-desktop'
          else
            t.format 'board-cant-be-moved-because-of-board-limits'

      t.input '.js-submit.wide.primary.disabled', { type: 'submit', value: if addToTeam then t.l('add') else t.l('change') }

      t.a { href: '#', class: 'js-new-org right-of-button-link' }, ->
        t.format 'create-team'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_change_board_org.coffee